var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewSheetsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1046 3C13.6964 3 11.7441 5.01472 11.7441 7.5V64.5C11.7441 66.9853 13.6964 69 16.1046 69H53.8953C56.3035 69 58.2558 66.9853 58.2558 64.5V21L40.8139 3H16.1046Z",
    fill: "#20A464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1046 69C13.6964 69 11.7441 66.9853 11.7441 64.5V63.75C11.7441 66.2353 13.6964 68.25 16.1046 68.25H53.8953C56.3035 68.25 58.2558 66.2353 58.2558 63.75V64.5C58.2558 66.9853 56.3035 69 53.8953 69H16.1046Z",
    fill: "#149456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1046 3C13.6964 3 11.7441 5.01472 11.7441 7.5V8.25C11.7441 5.76472 13.6964 3.75 16.1046 3.75H41.5407L40.8139 3H16.1046Z",
    fill: "#38AE74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2559 36.375V21L55.7123 18.375H43.4458C42.4746 18.375 41.9883 19.5868 42.675 20.2955L58.2559 36.375Z",
    fill: "url(#paint0_linear_5259_88247)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8145 3L58.2563 21H45.1749C42.7667 21 40.8145 18.9853 40.8145 16.5V3Z",
    fill: "#8ED1B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6289 35.25V57H23.373V35.25H46.6289ZM33.5475 38.25H26.28V42H33.5475V38.25ZM36.4544 42V38.25H43.7219V42H36.4544ZM33.5475 44.25H26.28V48H33.5475V44.25ZM36.4544 48V44.25H43.7219V48H36.4544ZM33.5475 50.25H26.28V54H33.5475V50.25ZM36.4544 54V50.25H43.7219V54H36.4544Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_88247",
    x1: 50.3047,
    y1: 36.375,
    x2: 50.3047,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207E55"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewSheetsIcon);
export default __webpack_public_path__ + "static/media/PreviewSheetsIcon.4a57333d32cff8f968f189eed6e3c80f.svg";
export { ForwardRef as ReactComponent };